import React from 'react';
import { WebsiteLayout } from '~/components/common/layout';
import { Chargeback } from '~/components/screens';

export default function PageWithLayout({ logout, user }) {
  return (
    <WebsiteLayout navbarBackgroundColor="white" user={user} handleLogout={logout}>
      <Chargeback />
    </WebsiteLayout>
  );
}
